<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card dark outlined>
          <v-card-title class="secondary py-1 text-subtitle-1">
            <v-icon left dense> mdi-cogs </v-icon>
            Layouts
            <v-spacer />
          </v-card-title>
          <v-card-text class="pa-0">
            <v-overlay :value="loading" absolute>
              <v-progress-circular
                indeterminate
                size="64"
                color="primary"
              ></v-progress-circular>
            </v-overlay>
            <v-data-table
              :headers="headers"
              :items="selectedLayouts"
              sort-by="LayoutId"
              single-select
              return-object
              class="elevation-5"
            >
              <template v-slot:item.Stalls="{ item }">
                <span
                  v-for="(stallName, index) in getActiveStallNames(item)"
                  :key="index"
                >
                  {{ stallName }}<br />
                </span>
              </template>

              <template v-slot:[`item.actions`]="{ item }">
                <v-icon small class="mr-2" @click="copyItem(item)">
                  mdi-content-copy
                </v-icon>
                <v-icon small class="mr-2" @click="editItem(item)">
                  mdi-pencil
                </v-icon>
                <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
              </template>

              <!-- Stallholder menu -->
              <template v-slot:top>
                <v-toolbar flat>
                  <v-row>
                    <v-col cols="4">
                      <v-autocomplete
                        :items="currentStallHolders"
                        v-model="selectedStallHolder"
                        item-text="StallholderName"
                        return-object
                        filled
                        dense
                        outlined
                        hide-details
                        label="Stallholders"
                        @change="handleChangeStallHolder"
                      >
                        <template v-slot:no-data>
                          <v-list-item>
                            <v-list-item-title>
                              <v-icon small color="red lighten-1">
                                mdi-information
                              </v-icon>
                              No event found
                            </v-list-item-title>
                          </v-list-item>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="2"> </v-col>
                  </v-row>

                  <v-row class="mt-2 mb-2">
                    <v-col cols="12"></v-col>
                  </v-row>
                  <v-dialog v-model="dialog" max-width="500px" dark>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        dark
                        class="mb-2"
                        @click="addLayout()"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon left x-small> mdi-plus </v-icon>
                        Add Layout
                      </v-btn>
                    </template>
                  </v-dialog>

                  <v-dialog v-model="dialogDeleteItem" max-width="520px">
                    <v-card>
                      <!-- #EBC09A -->
                      <v-card-title class="text-h6 text-wrap justify-center"
                        >Are you sure you want to delete this
                        layout?</v-card-title
                      >
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text @click="closeDelete">Cancel</v-btn>
                        <v-btn
                          color="red darken-1"
                          text
                          @click="deleteItemConfirmed"
                          >OK</v-btn
                        >
                        <v-spacer></v-spacer>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>

                  <v-dialog v-model="dialogCopyItem" max-width="500px" dark>
                    <v-card>
                      <v-card-title class="text-h6"> Copy Layout </v-card-title>
                      <v-card-text>
                        <v-text-field
                          v-model="copyLayoutName"
                          label="Layout Name"
                          outlined
                          dense
                          :rules="[(v) => !!v || 'Layout name is required']"
                        ></v-text-field>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text @click="closeCopy">Cancel</v-btn>
                        <v-btn
                          color="primary"
                          text
                          @click="saveCopy"
                          :disabled="!copyLayoutName"
                          >Save</v-btn
                        >
                        <v-spacer></v-spacer>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
              </template>

              <template v-slot:no-data>
                <v-btn color="primary"> No data available </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import "izitoast/dist/css/iziToast.min.css";
import iziToast from "izitoast/dist/js/iziToast.min.js";
import { mapState, mapActions, mapMutations } from "vuex";

export default {
  props: {
    productsData: {
      type: Object,
      default: () => ({
        layouts: [],
      }),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    dialog: false,
    dialogDeleteItem: false,
    dialogDeleteAllItems: false,
    dialogCopyItem: false,

    headers: [
      { text: "Layout Name", value: "LayoutName", width: "40%" },
      // {
      //   text: "Stallholder Name",
      //   value: "StallholderName",
      //   align: "left",
      //   width: "30%",
      // },
      { text: "Stalls", value: "Stalls", align: "left", width: "40%" },
      {
        text: "Actions",
        value: "actions",
        align: "right",
        width: "20%",
        sortable: false,
      },
    ],

    deleteItemId: "",
    copyLayoutName: "",
    itemToCopy: null,

    editedIndex: -1,
    editedItem: {
      StallholderId: "",
      LayoutId: "",
    },
    defaultItem: {
      StallholderId: "",
      StallId: "",
      TerminalUserId: "",
      TerminalId: "",
      LayoutId: "",
    },

    valid: true,
  }),

  computed: {
    ...mapState("filter", ["globalEventFilter"]),
    ...mapState("admin", [
      "processedLayout",
      "currentStallHolders",
      "currentStallholder",
      "currentStalls",
    ]),

    selectedLayouts() {
      return this.productsData.layouts || [];
    },

    formTitle() {
      return this.editedIndex === -1 ? "New Layout" : "Edit Layout";
    },

    selectedEvent: {
      get() {
        return this.globalEventFilter;
      },
      set(value) {
        console.log("EVENT IS CHANGED MAKE API REQUEST", value);
      },
    },

    selectedStallHolder: {
      get() {
        return this.currentStallholder;
      },
      set(value) {
        this.setCurrentStallholder(value);
      },
    },

    selectStallHolder: {
      get() {
        return this.currentStallholder;
      },
      set(value) {
        this.selectedStallholder = value;
      },
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDeleteItem(val) {
      val || this.closeDelete();
    },
    dialogCopyItem(val) {
      val || this.closeCopy();
    },
  },

  methods: {
    ...mapActions("admin", ["postLayouts"]),
    ...mapMutations("admin", ["setCurrentLayout", "setCurrentStallholder"]),

    handleChangeStallHolder: function (obj) {
      if (obj) {
        this.setCurrentStallholder(obj);
        // Note: Data will be refreshed by parent component
      }
    },

    addLayout: function () {
      // Set current layout and stallholder in store
      this.setCurrentLayout({});
      this.setCurrentStallholder(this.selectedStallHolder);

      this.$router.push({
        name: "Layout Configuration",
        params: {
          id: "create",
          layoutData: {},
          stallholderData: this.selectedStallHolder,
        },
      });
    },

    editItem(item) {
      console.log("editItem item: ", item);

      // Set current layout and stallholder in store
      this.setCurrentLayout(item);
      this.setCurrentStallholder(this.selectedStallHolder);

      this.$router.push({
        name: "Layout Configuration",
        params: {
          id: "update",
          layoutData: item,
          stallholderData: this.selectedStallHolder,
        },
      });
    },

    deleteItem(item) {
      console.log("deleteItem (item)", item);
      this.deleteItemId = item.LayoutId;
      this.dialogDeleteItem = true;
    },

    deleteItemConfirmed(item) {
      console.log("deleteItemConfirmed (item)", item);
      console.log("deleteItemConfirmed (item)", this.deleteItemId);

      try {
        if (this.deleteItemId) {
          let deletedItem = {
            Type: "Layout",
            Action: "delete",
            EventId: JSON.stringify(this.selectedEvent.EventId),
            LayoutId: this.deleteItemId,
          };

          console.log("DELETE: ", deletedItem);

          this.postLayouts(deletedItem)
            .then((response) => {
              console.log("deleteItemConfirmed: ", response);

              iziToast.success({
                title: "Layout",
                message: "Successfully deleted the Layout!",
                position: "topRight",
              });

              this.$emit("refresh-data");
            })
            .catch((err) => {
              console.log("ERROR: ", err);

              iziToast.warning({
                title: "Layout",
                message: "Failed to delete record!",
                position: "center",
              });
            });
        }
      } catch (e) {
        console.log(e);
      }

      this.closeDelete();
    },

    close() {
      this.dialog = false;

      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDeleteItem = false;

      this.deleteItemId = "";
    },

    copyItem(item) {
      // console.log('copyItem item: ', item)
      this.itemToCopy = item;
      this.copyLayoutName = item.LayoutName + " - Copy";
      this.dialogCopyItem = true;
    },

    saveCopy() {
      console.log("Original item to copy: ", this.itemToCopy);
      const itemToCopy = {
        Type: "Layout",
        Action: "create",
        StallholderId: this.itemToCopy.StallholderId,
        EventId: this.itemToCopy.EventId,
        LayoutName: this.copyLayoutName,
        Stalls: this.itemToCopy.Stalls,
        Layout: { Objects: this.itemToCopy.Objects },
      };

      // let eventSubmitItem =
      // {
      //     Type: "Layout",
      //     Action: "create",
      //     StallholderId: setStallholder.StallholderId,
      //     EventId: setEvent,
      //     LayoutName: "test",
      //     Stalls: [{StallId: 1, StallName: "test"}],
      //     Layout: {Objects:[{GroupName: "test", itemType: "Group", GroupType: "Standard", textColour: [], backgroundColour: []}]}
      // }
      // console.log('New layout name: ', itemToCopy)
      this.postLayouts(itemToCopy)
        .then((response) => {
          console.log("saveCopy response: ", response);

          iziToast.success({
            title: "Layout",
            message: "Successfully inserted record!",
            position: "topRight",
          });

          this.$emit("refresh-data");
        })
        .catch((err) => {
          console.log("ERROR: ", err);
        });

      this.closeCopy();
    },

    closeCopy() {
      this.dialogCopyItem = false;
      this.copyLayoutName = "";
      this.itemToCopy = null;
    },

    getActiveStallNames(item) {
      // Filter currentStalls array to find all stalls that match the LayoutId
      if (
        item.LayoutId &&
        this.currentStalls &&
        this.currentStalls.length > 0
      ) {
        const activeStalls = this.currentStalls.filter(
          (stall) => stall.LayoutId === item.LayoutId
        );
        if (activeStalls.length > 0) {
          return activeStalls.map((stall) => stall.StallName);
        }
      }
      return [];
    },
  },
};
</script>

<style scoped>
h1 {
  color: #a09c94;
  font-family: sans-serif;
}
.v-data-table-header th {
  white-space: nowrap;
}
</style>
